/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Col_FeatureInputs */

const en_pc_cmp_col_feature = /** @type {(inputs: Pc_Cmp_Col_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature`)
};

const zh_pc_cmp_col_feature = /** @type {(inputs: Pc_Cmp_Col_FeatureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`功能`)
};

/**
* | output |
* | --- |
* | "Feature" |
*
* @param {Pc_Cmp_Col_FeatureInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_col_feature = /** @type {((inputs?: Pc_Cmp_Col_FeatureInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Col_FeatureInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_col_feature(inputs)
	return zh_pc_cmp_col_feature(inputs)
});
export { pc_cmp_col_feature as "pc.cmp.col_feature" }